import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';

export default function AdminLogin() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const r = await api.post('/admin/auth/login', form);
      localStorage.setItem('admin_token', r.data.token);
      navigate('/admin/dashboard');
    } catch (e) { setError(e.response?.data?.error || 'Login failed'); }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#1a2744', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 40, width: '100%', maxWidth: 400, boxShadow: '0 16px 48px rgba(0,0,0,0.3)' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ width: 52, height: 52, background: '#c9a227', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900, fontSize: 22, color: '#1a2744', margin: '0 auto 16px' }}>PP</div>
          <h1 style={{ fontSize: 20, fontWeight: 800, color: '#1a2744', marginBottom: 4 }}>Admin Portal</h1>
          <p style={{ fontSize: 13, color: '#9a9a9a' }}>Premier Pawn & Tech Repair</p>
        </div>
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group"><label className="form-label">Username or Email</label><input className="form-control" type="text" autoComplete="username" value={form.username} onChange={e => setForm(f => ({...f, username: e.target.value}))} autoFocus required /></div>
          <div className="form-group"><label className="form-label">Password</label><input className="form-control" type="password" value={form.password} onChange={e => setForm(f => ({...f, password: e.target.value}))} required /></div>
          <button type="submit" className="btn btn-navy btn-lg" style={{ width: '100%', justifyContent: 'center', marginTop: 8 }} disabled={loading}>{loading ? 'Signing in...' : 'Sign In'}</button>
        </form>
      </div>
    </div>
  );
}
